import { render, staticRenderFns } from "./ReportReceipt.vue?vue&type=template&id=1a487c48"
import script from "./ReportReceipt.vue?vue&type=script&lang=js"
export * from "./ReportReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports